import { Icon } from '@design';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useEarningsStore } from '../../useEarningsStore/useEarningsStore';
import styles from './EarningsManualEditOptions.module.scss';

export const EarningsManualEditOptions = () => {
  const { t } = useTranslation();
  const { resetSelectionByManualEdit } = useEarningsStore();
  return (
    <div className={styles.manualEditOptionsWrapper}>
      <div className={styles.iconAndLabelWrapper}>
        <Icon iconName="InformationLightCircle" size={20} />
        <span className={styles.manualEditOptionsLabelText}>
          {t('widget:earnings.earningsScenario.manualChangesMade')}
        </span>
      </div>

      <div
        className={styles.clickableIconAndLabelWrapper}
        onClick={resetSelectionByManualEdit}
      >
        <Icon iconName="Reset" size={20} />
        <span className={styles.manualEditOptionsLabelText}>
          {t('widget:earnings.earningsScenario.resetManualEdits')}
        </span>
      </div>
    </div>
  );
};
